<template>
  <b-card title="اطلاعات کاربری">
    <b-alert :show="errors.length > 0" variant="danger">
      <p v-for="item of errors" v-bind:key="item">{{ item }}</p>
    </b-alert>
    <b-row>
      <b-col cols="12" md="3">
        <b-form-group
          id="example-input-group-1"
          label="نوع حساب:"
          label-for="example-input-1"
        >
          <MDDropdown
            :disabled="disabled"
            v-bind:group="17"
            v-model="typeCustomer"
          ></MDDropdown>
          <b-form-invalid-feedback id="input-1-live-feedback"
            >وارد کردن نام اجباری است</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>
    </b-row>

    <RealInformation
      v-if="typeCustomer === 1550"
      @validattion="validation"
      :submitted="submitted"
    />
    <LegalInformation
      v-if="typeCustomer === 1551"
      @validattion="validation"
      :submitted="submitted"
      :loadedUserInformation="loadedUserInformation"
    />
  </b-card>
</template>


<script>
import { REGISTER } from "@/core/services/store/register.module";
import { GETUSER } from "@/core/services/store/getUser.module";
import { validationMixin } from "vuelidate";
import LegalInformation from "../../components/RegisterStep/LegalInformation.vue";
import RealInformation from "../../components/RegisterStep/RealInformation.vue";
import MDDropdown from "../../components/MDDropdown";

export default {
  name: "information",
  mixins: [validationMixin],
  components: {
    LegalInformation,
    RealInformation,
    MDDropdown,
  },
  data() {
    return {
      submitted: false,
      errors: [],
      typeCustomer: 1550,
      disabled: false,
      loadedUserInformation: {
        //   fa_name: "",
        // fa_family: "",
        // en_name: "",
        // en_family: "",
        // national_card_number: "",
        // id_number: "",
        // pre_phone: "",
        // fa_father: "",
        // en_father: "",
        // phone: "",
        // mdid18_gender: "",
        // birth_date: "",
        // mdid4_province: "",
        // mdid5_city: "",
        // address: "",
        // postalCode: "",
      },
    };
  },
  watch: {},
  computed: {},
  mounted() {
    let query;
    query = this.$route.query.status;
    if (query !== undefined) {
      this.disabled = true;
    }
  },
  methods: {
    getUser() {
      this.$store.dispatch(GETUSER).then((data) => {
        Object.assign(this.loadedUserInformation, data);
      });
    },
    validation(user) {
      this.submitted = true;
      Object.assign(user, { mdid17_merchant_type: this.typeCustomer });
      this.$store
        .dispatch(REGISTER, user)
        .then((value) => {
          if (value.success) {
            this.$router.push({
              path: "/dashboard",
              query: { from: "information" },
            });
          } else {
            this.errors = [];
            for (const key in value.error) {
              if (value.error.hasOwnProperty(key)) {
                const element = value.error[key];
                this.$makeToast("danger", "خطای سمت سرور", element, 4000);
              }
            }
            this.toTop();
          }
        })
        .catch((error) => {
          this.$makeToast(
            "danger",
            "خطای سمت سرور",
            `لطفا در زمان دیگری عملیات مورد نظر را انجام دهید.`,
            6000
          );
        })
        .finally(() => {
          this.submitted = false;
        });
    },
    toTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style>
.form-control.is-invalid, .was-validated .form-control:invalid {
  padding-right: calc(1.5em + 1.3rem);
}
.form-control.is-valid, .was-validated .form-control:valid {
  padding-right: calc(1.5em + 1.3rem);
}
.custom-select.is-valid, .was-validated .custom-select:valid{
  padding-right: calc(1.5em + 1.3rem);
}
</style>

